module.exports = __webpack_public_path__ + "img/acf6e169a1694012b0b30efc536598b7.6cfcc516.jpg";